import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-auth p-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-circle" }, null, -1)
const _hoisted_4 = { class: "username" }
const _hoisted_5 = {
  key: 1,
  class: "username"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.authState && _ctx.authState.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.authState.idToken.claims.email), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.authState || !_ctx.authState.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Not Logged In "))
      : _createCommentVNode("", true)
  ]))
}